import actionTypes from './actionTypes';

const logout = () => ({
    type: actionTypes.USER_LOGOUT
});

const requestUserLoginStatus = partyKey => ({
    type: actionTypes.REQUEST_USER_LOGIN_STATUS,
    payload: {
        partyKey
    }
});

const userLoginStatusResponse = (isLoggedIn, partyKey) => ({
    type: actionTypes.USER_LOGIN_STATUS_RESPONSE,
    payload: {
        isLoggedIn,
        partyKey
    }
});

export default {
    logout,
    requestUserLoginStatus,
    userLoginStatusResponse
};